import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-20 ant-col-xl-20" }
const _hoisted_3 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_6 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_uso_arma = _resolveComponent("selecionar-tipo-uso-arma")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, { titulo: "Detalhes do Armamento" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_form_item, {
            label: "Descrição",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "ant-input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedRastreabilidadeArmamento.descricao) = $event))
              }, null, 512), [
                [_vModelText, _ctx.computedRastreabilidadeArmamento.descricao]
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_form_item, {
            label: "Tipo Uso",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_tipo_uso_arma, {
                valor: _ctx.computedRastreabilidadeArmamento.tipoUsoArma,
                "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedRastreabilidadeArmamento.tipoUsoArma) = $event))
              }, null, 8, ["valor"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_form_item, {
            label: "Número de Série da Arma",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "ant-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedRastreabilidadeArmamento.numeroSerieArma) = $event))
              }, null, 512), [
                [_vModelText, _ctx.computedRastreabilidadeArmamento.numeroSerieArma]
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_form_item, {
            label: "Número de Série do Cano",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "ant-input",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedRastreabilidadeArmamento.numeroSerieCano) = $event))
              }, null, 512), [
                [_vModelText, _ctx.computedRastreabilidadeArmamento.numeroSerieCano]
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}